import React, {Component} from 'react';
import Button from "../button";

class Popover extends Component{

    constructor(props){
        super(props);
        this.state = {
            isDisplayed: false
        }
    }

    onOpen = () => {
        this.setState({
            ...this.state,
            isDisplayed: true
        })
    };

    onClose = () => {
        this.setState({
            ...this.state,
            isDisplayed: false
        })
    };

    onAccept = () => {
        this.setState({
            ...this.state,
            isDisplayed: false
        });
        this.props.onAccept();
    };

    render() {
        const {children, title} = this.props;
        return (
            <div
                className={'inlineBlock'}
                style={{position: 'relative'}}
            >
                <div onClick={this.onOpen}>
                    {children}
                </div>
                {this.state.isDisplayed && (
                    <div className={'popover top popover__confirmation'} role={'tooltip'}>
                        <div className="arrow"/>
                        <h3 className="popover-title">{title}</h3>
                        <div className="popover-content">
                            <Button
                                clickHandler={this.onAccept}
                                wrapper="btn-wrapper"
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow mr-15'}
                                label="Yes"
                            />
                            <Button
                                clickHandler={this.onClose}
                                wrapper="btn-wrapper"
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                label="No"
                            />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default Popover;